/**
 * The external dependencies.
 */
import {createAction} from 'redux-actions';

/**
 * Set current task view - TODO Refactor for all main task types
 * Shop/Stock/Working
 *
 * @type   {Function}
 * @return {Object}
 */
export const taskViewSet = createAction('task-view/set');

export const workPlanner = createAction('work-planner');
export const workProductionManager = createAction('production-manager', (message, taskid) => ({message, taskid}));
export const workDispatcher = createAction('dispatcher');
export const workQa = createAction('qa', (task) => ({task}));

export const emailSent = createAction('email-sent');



// WEBPACK FOOTER //
// ./src/store/task-view/actions.js